import { NgModule, ModuleWithProviders } from '@angular/core';
import { SharedModule } from 'projects/sepidz-web-framework-shell/src/lib/shared/shared.module';
import { ErrorDialogModule } from 'projects/sepidz-web-framework/src/lib/services/error-dialog/error-dialog.module';
import { KGridComponent } from './kgrid.component';
import { GridModule, ExcelModule, PDFModule, FilterService } from '@progress/kendo-angular-grid';
import { SepidzMessageService } from './sepidz-message.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { EditableGridComponent } from './editable-grid/editable-grid.component';
import { EditabeltreelistComponent } from './editabletreelist/editabeltreelist.component';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';
import { PopupAnchorDirective } from './editable-grid/popup.anchor-target.directive';
import { ThemeModule } from 'projects/sepidz-web-framework-shell/src/lib/@theme/theme.module';
import { ReportCopyComponent } from './report-selector/report-copy.component';
import { ReportSelectorComponent } from './report-selector/report-selector.component';
const components = [
  KGridComponent,
  EditableGridComponent,
  EditabeltreelistComponent,
  ReportCopyComponent,
  ReportSelectorComponent
]
@NgModule({
    declarations: [
        ...components,
        PopupAnchorDirective
    ],
    imports: [
        ReactiveFormsModule,
        SharedModule.forRoot(),
        ErrorDialogModule,
        GridModule,
        ExcelModule,
        PDFModule,
        TreeListModule,
        DropDownListModule,
        PopupModule,
        ThemeModule.forRoot(),
    ],
    exports: [
        ...components,
        GridModule,
        ExcelModule,
        PDFModule,
        PopupAnchorDirective,
        DropDownListModule
    ],
    providers: [
        { provide: MessageService, useClass: SepidzMessageService},
    ]
})
export class SepidzGridModule {
  static forRoot(): ModuleWithProviders<SepidzGridModule> {
    return {
      ngModule: SepidzGridModule,
    };
  }
}
